import { render, staticRenderFns } from "./selectDeclaration.vue?vue&type=template&id=4364ab48"
import script from "./selectDeclaration.vue?vue&type=script&lang=js"
export * from "./selectDeclaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports